import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
/**
 * String, TypedArray and Base64 encoders/decoders.
 *
 * @module codec
 * @license Apache-2.0
 * @author drmats
 */

import { head, tail } from "./array";
import { compose, curry } from "./func";
import { inc, sum } from "./math";
import { empty } from "./string";
import { isNumber } from "./type";
import { isBrowser } from "./utils";
export var concatBytes = function concatBytes() {
  for (var _len = arguments.length, u8as = new Array(_len), _key = 0; _key < _len; _key++) {
    u8as[_key] = arguments[_key];
  }

  if (u8as.length === 0) return new Uint8Array();
  if (u8as.some(function (u8a) {
    return !isNumber(u8a.BYTES_PER_ELEMENT);
  })) throw new TypeError("Arguments must be of [TypedArray] type.");
  var result = new Uint8Array(sum(u8as.map(function (u8a) {
    return u8a.length;
  })));
  u8as.reduce(function (pointer, u8a) {
    result.set(u8a, pointer);
    return pointer + u8a.length;
  }, 0);
  return result;
};
export var compareBytes = curry(function (u8a1, u8a2) {
  if (!isNumber(u8a1.BYTES_PER_ELEMENT) || !isNumber(u8a2.BYTES_PER_ELEMENT)) throw new TypeError("Arguments must be of [TypedArray] type.");
  if (u8a1.BYTES_PER_ELEMENT !== u8a2.BYTES_PER_ELEMENT || u8a1.length !== u8a2.length) return false;

  for (var i = 0; i < u8a1.length; i = inc(i)) {
    if (u8a1[i] !== u8a2[i]) return false;
  }

  return true;
});
export var stringToBytes = isBrowser() ? function (s) {
  return new TextEncoder("utf-8").encode(s);
} : function (s) {
  return Uint8Array.from(Buffer.from(s));
};
export var bytesToString = isBrowser() ? function (bytes) {
  return new TextDecoder("utf-8").decode(bytes);
} : function (bytes) {
  return Buffer.from(bytes).toString();
};
export var hexToBytes = function hexToBytes(hexInput) {
  return function (hex) {
    return Uint8Array.from(hex.split(empty()).reduceRight(function (acc, el, i) {
      return i % 2 ? [el].concat(_toConsumableArray(acc)) : [el + head(acc)].concat(_toConsumableArray(tail(acc)));
    }, []).map(function (hexByte) {
      return parseInt(hexByte, 16);
    }));
  }(hexInput.replace(/(\s)|(^0x)/g, empty()));
};
export var bytesToHex = function bytesToHex(bytes) {
  return Array.from(bytes).map(function (b) {
    return b < 16 ? "0" + b.toString(16) : b.toString(16);
  }).join(empty());
};
export var b64dec = isBrowser() ? function (s) {
  return Uint8Array.from(atob(s).split(empty()).map(function (c) {
    return c.charCodeAt(0);
  }));
} : function (s) {
  return Uint8Array.from(Buffer.from(s, "base64"));
};
export var b64enc = isBrowser() ? function (bytes) {
  return btoa(_toConsumableArray(bytes).map(function (b) {
    return String.fromCharCode(b);
  }).join(empty()));
} : function (bytes) {
  return Buffer.from(bytes).toString("base64");
};
export var b64ToString = compose(bytesToString, b64dec);
export var stringToB64 = compose(b64enc, stringToBytes);
export var b64ToHex = compose(bytesToHex, b64dec);
export var hexToB64 = compose(b64enc, hexToBytes);